module.exports = __webpack_public_path__ + "static/media/LogosTorrens.da9df500.jpeg";